import { render, staticRenderFns } from "./newAnnouncement.vue?vue&type=template&id=7f9478aa&scoped=true"
import script from "./newAnnouncement.vue?vue&type=script&lang=js"
export * from "./newAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./newAnnouncement.vue?vue&type=style&index=0&id=7f9478aa&prod&scoped=true&lang=scss"
import style1 from "./newAnnouncement.vue?vue&type=style&index=1&id=7f9478aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9478aa",
  null
  
)

export default component.exports